import { InitialState } from "./initialState";

export const AppActions = {
  AddConfig: "AddConfig",
  AddSession: "AddSession",
  AddTradeData: "AddTradeData",
  updatePageState: "updatePageState",
  updateTheme: "updateTheme",
  AppendJobFeedLog: "AppendJobFeedLog",
  ClearJobFeedLog: "ClearJobFeedLog",
};

const Reducers = (state, action) => {
  switch (action.type) {
    case "AddConfig":
      if (action.payload.env) {
        return {
          ...state,
          config: {
            ...state.config,
            ...action.payload,
            env: { ...state.config.env, ...action.payload.env },
          },
        };
      }
      return { ...state, config: { ...state.config, ...action.payload } };
    case "AddSession":
      return { ...state, session: { ...state.session, ...action.payload } };
    case "AddTradeData":
      return { ...state, tradeData: { ...state.tradeData, ...action.payload } };
    case "updatePageState":
      return { ...state, pageState: { ...state.pageState, ...action.payload } };
    case "updateTheme":
      return { ...state, theme: { ...state.theme, ...action.payload } };
    case "AppendJobFeedLog":
      return { ...state, jobFeedLog: (state.jobFeedLog || "") + (action.payload ?? "") };
    case "ClearJobFeedLog":
      return { ...state, jobFeedLog: "" };
    default:
      return state;
  }
};

export default Reducers;
